import styled from 'styled-components';
import {
	headerHeight,
	mobileFooterPadding,
	mobileThreshold,
} from '../../Constants/layoutValues';
import { cssVarColors } from '../../Constants/cssVarColors';

export const HomepageFooterWrapper = styled.div`
  position: relative;
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	@media (max-width: ${mobileThreshold}px) {
		//background-color: green;
		//height: 500px;
	}
`;

export const ContentWrapper = styled.div`
   position: relative;
	padding-top: 2em;
	color: #fff;
	height: 100%;
	width: calc(100% - ${mobileFooterPadding});
	display: flex;
	flex-direction: column;
	align-items: center;
	@media (max-width: ${mobileThreshold}px) {
		padding-top: 0;
	  //padding-top: ${headerHeight};
	}
`;

export const LogoWrapper = styled('div')`
  padding-left: 1em;
  font-size: 2.5em;
  flex: 3;
  display: flex;
  align-items: flex-start;
  @media (max-width: ${mobileThreshold}px) {
    //padding-bottom: 1em;
  }
`;

export const LinksWrapper = styled.div`
	width: 100%;
	justify-content: space-around;
	display: flex;
	flex-direciton: row;
	flex-grow: 1;
	flex: 1;
	@media (max-width: ${mobileThreshold}px) {
	  //padding-top: 1em;
		flex-wrap: wrap;
	  overflow: hidden;
	}
`;

export const SocialWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	min-height: 50px;
	width: 100%;
	@media (max-width: ${mobileThreshold}px) {
		padding-top: 1em;
		height: auto;
	}
`;
